import { ExpertRole } from "../types/ExpertRole"
import { useExpertsByRole } from "./useExpertsByRole"

export const useSpecialist = () => {
    const { expert: specialist, fetchExpert: fetchSpecialist } = useExpertsByRole(ExpertRole.Specialist)
    return { specialist, fetchSpecialist }
}